<template>
  <div>
    <h1 class="modal-h1 mb-3">
      <button type="button"
              class="btn btn-back"
              @click="$emit('cancel')"
      />
      Create Claim Type
    </h1>
    <div class="l-bg-white">
      <form @submit.prevent="submit"
            autocomplete="no"
      >
        <div class="row mb-3">
          <div class="col-12">
            <div class="select-wrap">
              <label>Claim type name</label>
              <input v-model="claimType.name"
                     type="text"
                     placeholder="Enter Name"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col text-right">
            <button type="button"
                    class="btn btn-secondary"
                    @click="$emit('cancel')"
            >
              Cancel
            </button>
            <button class="btn btn-primary ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
            >
              Create
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import ErrorField from '../../ErrorField';
import Errors from '../../../classes/Errors';

export default {
  name: 'CreateClaimType',
  components: {
    ErrorField,
  },
  data: () => ({
    claimType: {
      name: '',
    },
    loadingButton: false,
    buttonDisabled: false,
    errors: new Errors(),
  }),
  methods: {
    submit() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .post('claims/types', this.claimType)
        .then(() => {
          toastr.success('Successfully created claim type');
          this.$emit('update');
          this.$emit('cancel');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/ClaimTypes/SettingsCreateClaimType.vue